import {Component, Input, OnInit} from '@angular/core';
import {ApexOptions} from "ng-apexcharts";
import {numberWithCommas} from "../../BATCH_COLORS";

@Component({
    selector: 'app-val-premoney-batch-bar-chart',
    templateUrl: './val-premoney-batch-bar-chart.component.html',
    styleUrls: ['./val-premoney-batch-bar-chart.component.scss']
})
export class ValPremoneyBatchBarChartComponent {
    private _appForPremoney: any;
    get appForPremoney() {
        return this._appForPremoney;
    }

    @Input() set appForPremoney(val: any) {
        this._appForPremoney = val;
        if (val) {
            this.premoneyAvgforBatchChart = {
                series: this.appForPremoney.avgValForBatch.series,
                chart: {
                    type: "bar",
                    animations: {
                        speed: 400,
                        animateGradually: {
                            enabled: false
                        }
                    },
                    fontFamily: 'inherit',
                    foreColor: 'inherit',
                    width: '100%',
                    height: '100%',
                    stacked: false,
                    toolbar: {
                        show: true
                    },
                },
                dataLabels: {
                    enabled: true,
                    formatter: (val) => {
                        return numberWithCommas(val);
                    },
                    // offsetY: -20,
                    style: {
                        fontSize: "14px",
                    }
                },
                plotOptions: {
                    bar: {
                        horizontal: true
                    }
                },
                stroke: {
                    width: 1,
                    colors: ["#fff"]
                },
                xaxis: {
                    categories: this.appForPremoney.avgValForBatch.categories,
                    labels: {
                        // style: {
                        //     colors: 'var(--fuse-text-secondary)'
                        // },
                        formatter: (value) => {
                            return `${numberWithCommas(value)}`;
                        },
                    },
                },
                yaxis: {
                    labels : {
                        style : {
                            fontWeight : 'bold'
                        }
                    }
                },
                colors: ['rgb(89, 214, 149)'],
                tooltip: {
                    y: {
                        formatter:  (val) =>{
                            return `${numberWithCommas(val)}`;
                        }
                    }
                },
                fill: {
                    opacity: 1
                },
                legend: {
                    position: "top",
                    horizontalAlign: "center",
                    offsetX: 40
                }
            };

        }
    }

    premoneyAvgforBatchChart: ApexOptions;

    constructor() {
    }

}
